exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pics-index-js": () => import("./../../../src/pages/pics/index.js" /* webpackChunkName: "component---src-pages-pics-index-js" */),
  "component---src-pages-pics-mdx-slug-js": () => import("./../../../src/pages/pics/{mdx.slug}.js" /* webpackChunkName: "component---src-pages-pics-mdx-slug-js" */)
}

